import { Base, Img, Span } from "@codesuma/baseline"
import images from '../../configs/images'

export const GoogleButton = () => {
    const base = Base()
    const google = Img(images.icons.google, { width: 24 })
    const txt = Span('Login using google')
    txt.style({
        marginLeft: '10px',
    })

    base.append(google, txt)
    base.style({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #eee',
        borderRadius: '10px',
        padding: '10px',
        width: '100%',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#fefefe',
        }
    })

    base.el.onclick = async () => {
        txt.text('Logging in...')
        base.emit('request-login')
    }

    // Restores the label after a cancelled/failed attempt so the button doesn't
    // read "Logging in..." forever.
    return Object.assign(base, {
        reset: () => txt.text('Login using google'),
    })
}